module.exports = __webpack_public_path__ + "static/media/Soups.149c686a.svg";